declare const I18n;

import React from "react";
import SkillHeading from "./WomenInStem/Heading";
import WomenInStemCard from "./WomenInStem/WomenInStemCard";

type BadgeIndexProps = {
  groupedBadges: Record<string, any[]>;
};

const BadgeIndex: React.FC<BadgeIndexProps> = ({ groupedBadges }) => {
  return (
    <div className="skills-container">
      {Object.entries(groupedBadges).map(([skillSlug, badges]) => {
        const sortedBadges = badges.sort((a, b) => a.pointsRequired - b.pointsRequired);

        return (
          <div key={skillSlug} className="skill-section">
            <SkillHeading skillSlug={skillSlug} />

            <div className="skills-grid-admin">
              {sortedBadges.map((badge) => (
                <>
                  <WomenInStemCard
                    key={badge.id}
                    name={badge.name}
                    skillSlug={skillSlug}
                    unlocked={true}
                    isNew={false}
                    currentPoints={badge.currentPoints}
                    pointsRequired={badge.pointsRequired}
                    info={badge.description}
                    imageUrl={badge.file_url}
                    isAdmin={true}
                    badgeId={badge.id}
                    learnMoreUrl={badge.learn_more_url}
                  />
                </>
              ))}
            </div>
            <a href={`/admin/badges/new?skill=${skillSlug}`} className="btn btn-primary">
              <i className="fa-solid fa-plus"></i> {I18n.t("views.achievements.common.add_badge")}
            </a>
          </div>
        );
      })}
    </div>

  );
};

export default BadgeIndex;
